import { Spinner } from '@chakra-ui/react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import React from 'react';

import { useAppSelector } from '@/store/hooks';
import { ConfigHelper } from '@/utils/env';

type Wrapper = ({ children }: { children: React.ReactNode }) => React.JSX.Element;

const LDProviderWrapper = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const passport = useAppSelector((state) => state.auth.userPassport);
  const [ldHydrated, setLDHydrated] = React.useState<boolean>(false);
  const LDProviderRef = React.useRef<Wrapper | null>(null);

  React.useEffect(() => {
    if (passport && isAuthenticated) {
      (async () => {
        LDProviderRef.current = await asyncWithLDProvider({
          clientSideID: ConfigHelper.ldClientKey ?? '',
          context: {
            custom: {
              customerId: passport?.user.customer_id,
              empId: passport?.user.emp_id,
              isAdmin: passport?.user.is_admin,
              userId: passport?.user.user_id,
            },
            email: passport?.user.email,
            key: `${passport?.user.customer_id}_${passport?.user.emp_id}`,
            kind: 'user',
            name: passport?.user.user_name,
          },
        });

        setLDHydrated(true);
      })();
    }
  }, [isAuthenticated, passport]);

  // Waiting on hydration
  if (isAuthenticated) {
    if (!ldHydrated || !LDProviderRef.current || !passport) return <Spinner />;

    if (ldHydrated && LDProviderRef.current) return <LDProviderRef.current>{children}</LDProviderRef.current>;
    throw new Error('Could not initialize Launch Darkly');
  }

  // Not authenticated
  return <>{children}</>;
};

export default LDProviderWrapper;
